import { render, staticRenderFns } from "./company0001.vue?vue&type=template&id=296cc6d0&"
import script from "./company0001.vue?vue&type=script&lang=js&"
export * from "./company0001.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports